<template>
    <div class="detail-comment" ref="commentContainer">
        <loading v-if="loading"></loading>
        <template v-if="!loading">
            <div class="title">顾客点评</div>
            <div class="comment-header" v-if="commentInfo.selectedTypeList && commentInfo.selectedTypeList.length">
            	<ul class="clearfix">
        			<li v-for="typeItem in commentInfo.selectedTypeList" @click="changeType(typeItem.selectedType, typeItem.isSelected)" :class="{active: typeItem.isSelected}" :key="typeItem.selectedType">
                        {{ typeItem.selectedName }}
                    </li>
            	</ul>
            </div>
            <div v-if="commentInfo.list && commentInfo.list.length">
                <div v-for="(item, index) in commentInfo.list" v-if="item.content" class="comment-content" :key="item.contentId">
                    <div class="c-item-header">
                        <span class="icon-destination0"></span>
                        <div>
                            <span class="c-username">{{ item.realName }}</span>
                            <span class="c-time">{{ item.remarkTime }}</span>
                        </div>
                        <span class="c-satis">{{ item.compGrade == 3 ? '满意':(item.compGrade === 0 ? '不满意':'一般') }}</span>
                        <span class="c-type">{{ item.travelTypeName === '其他' ? '' : item.travelTypeName }}</span>
                    </div>
                    <div class="c-desc" ref="textContainer" @click="toggleContent">
                        <div class="c-desc-container"><p>{{ item.content }}</p></div>
                        <div class="comment-dropdown"><span class="icon-putaway"></span></div>
                    </div>
                    <div v-if="item.subRemark && item.subRemark.length" class="c-detail" ref="textContainer" @click="toggleContent">
                        <div class="c-detail-container">
                            <ul>
                                <li v-for="(sr, i) in item.subRemark" :key="i">
                                    <span>{{ sr.category }}：</span><p>{{ sr.content }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="comment-dropdown-t"><span class="icon-putaway"></span></div>
                    </div>
                    <div v-if="item.images && item.images.length" class="c-img-list">
                        <ul class="clearfix">
                            <li v-for="(img, i) in item.images" v-if="i < 3" :key="img.thumbUrl">
                                <img :src="replaceProtocol(img.thumbUrl)" alt="" @click="openPreview(index, i)">
                            </li>
                        </ul>
                        <div v-if="item.images.length > 3" class="c-img-count">
                            <span>共{{ item.images.length }}张</span>
                            <div class="c-count-bg"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="commentInfo.list" class="no-comment">新品上线 暂无点评</div>
        	<div v-if="commentInfo.pageNum > 1" class="pager-box" id="pagerBox">
        		<a id="prev" :class="{active: commentInfo.currentPage > 1}" class="pager" @click="changePage(-1)">上一页</a>
        		<span id="currentPage">{{commentInfo.currentPage}}</span>
        		<a id="next" :class="{active: commentInfo.currentPage < commentInfo.pageNum}" class="pager" @click="changePage(1)">下一页</a>
        	</div>

            <Previewer :photos="imgList" :start-page="imgIndex" v-show="showPreview" v-on:closePreview="closePreview"></Previewer>
        </template>
    </div>
</template>

<script>
import commentStoreModule from '@/store/modules/comment';
import Loading from '@/components/Loading';
import Previewer from '@/components/Previewer';

export default {
    props: {
        showComment: {
            type: Boolean,
            default: function () {
                return true;
            }
        }
    },
    data() {
        return {
            showPreview: false,
            imgList: [],
            imgIndex: 0
        }
    },
    components: {
        Previewer,
        Loading
    },
    created () {
        this.$store.registerModule('comment', commentStoreModule);
    },
    mounted() {
        if (!this.commentInfo.list && this.showComment) {
            this.getComments();
        }
    },
    updated() {
        (this.$refs.textContainer || []).forEach(el => {
            let className = el.className;
            let contentHeight = 0;
            let limitHeight = 0;
            if (~className.indexOf('c-desc')) {
                limitHeight = 150;
                contentHeight = el.querySelector('p').offsetHeight;
            }
            if (~className.indexOf('c-detail')) {
                limitHeight = 102;
                contentHeight = el.querySelector('ul').offsetHeight;
            }
            if (contentHeight > limitHeight && !~el.className.indexOf('ellipsis')) {
                el.className += ' ellipsis';
            }
        });
    },
    destroyed () {
        this.$store.unregisterModule('comment')
    },
    watch: {
        showComment (val) {
            if (val) {
                this.getComments();
            }
        }
    },
    computed: {
        baseInfo () {
            return this.$store.state.detail && this.$store.state.detail.baseInfo;
        },
        loading () {
            return this.$store.state.comment.commentLoading;
        },
        commentInfo () {
            return this.$store.state.comment.commentInfo;
        }
    },
    methods: {
        getComments() {
            let params = {
                productId: this.baseInfo.selfPrdId ? this.baseInfo.selfPrdId : this.baseInfo.productId
            };
            if (this.commentInfo.currentPage !== undefined) {
                params.page = this.commentInfo.currentPage;
            }
            if (Array.isArray(this.commentInfo.selectedTypeList) && this.commentInfo.selectedTypeList.find(el => el.isSelected)) {
                params.selectedType = this.commentInfo.selectedTypeList.find(el => el.isSelected).selectedType;
            }
            this.$store.dispatch('comment/getComment', params);
        },
        replaceProtocol(url) {
            return url ? url.replace(/^http:|^https:/g, 'https:') : ''
        },
        toggleContent(event) {
            let className = event.currentTarget.className;
            if (~className.indexOf('ellipsis')) {
                if (~className.indexOf('expand')) {
                    event.currentTarget.className = className.replace(' expand', '');
                } else {
                    event.currentTarget.className += ' expand';
                }
            }
        },
        changePage(offset) {
            let page = (this.commentInfo.currentPage || 0) + offset;
            if (page >= 1 && page <= this.commentInfo.pageNum) {
                this.$store.dispatch('comment/changeCommentPage', { page });
                this.$nextTick(this.getComments());
                window.scrollTo(0, this.$refs.commentContainer.offsetTop - 107);
            }
        },
        changeType(type, isCurr) {
            if (isCurr) {
                return;
            }
            this.$store.dispatch('comment/changeCommentType', { type });
            this.$store.dispatch('comment/changeCommentPage', { page: 1 });
            this.$nextTick(this.getComments());
            window.scrollTo(0, this.$refs.commentContainer.offsetTop - 107);
        },
        openPreview(index, start) {
            this.imgList = this.commentInfo.list[index].images.map(img => {
                return this.replaceProtocol(img.originalUrl);
            });
            this.imgIndex = start;
            this.showPreview = true;
        },
        closePreview() {
            this.showPreview = false;
        }
    }
}
</script>

<style lang="scss">

.detail-comment .title {
    height: 24px;
    font-size: 20px;
    color: #383838;
    margin: 8px 0;
}

.detail-comment .comment-header {
    background-color: #fff;
    padding: 15px 0 5px 0;
    ul {
        background-color: white;
        li {
            float: left;
            color: #23cc77;
            border: 1px solid #23cc77;
            padding: 5px 7px;
            border-radius: 5px;
            margin-right: 10px;
            margin-bottom: 10px;
            touch-action: manipulation;
            &.active {
                color: #fff;
                background-color: #23cc77;
            }
            &.negative {
                color: #ccc;
                border: 1px solid #ccc;
            }
        }
    }
}

.detail-comment .comment-content {
    background-color: #fff;
    padding: 15px 0;
    margin-top: 10px;
    .c-item-header {
        position: relative;
        margin-bottom: 15px;
        // padding: 0 15px;
        .icon-people {
            display: inline-block;
            font-size: 15px;
            vertical-align: top;
            padding-right: 4px;
        }
        div {
            display: inline-block;
            span {
                display: block;
            }
            .c-username {
                font-size: 14px;
                color: #222;
                padding-top: 0px;
            }
            .c-time {
                font-size: 12px;
                color: #999;
                margin-top: 8px;
            }
        }
        .c-satis {
            position: absolute;
            top: -3px;
            left: 135px;
            display: inline-block;
            background-color: #23cc77;
            color: #fff;
            width: auto;
            padding: 0 8px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 10px;
        }
        .c-type {
            position: absolute;
            right: 15px;
            top: 0;
            font-size: 15px;
            color: #23cc77;
        }
    }
    .c-desc {
        // padding: 0 15px;
        margin-bottom: 10px;
        touch-action: manipulation;
        .c-desc-container {
            font-size: 14px;
            line-height: 21px;
            color: #222;
            max-height: 150px;
            overflow: hidden;
        }
    }
    .c-detail {
        padding: 15px 15px 10px;
        background-color: rgba(240,244,247,.4);
        color: #999;
        font-size: 14px;
        margin-bottom: 10px;
        touch-action: manipulation;
        .c-detail-container {
            max-height: 102px;
            overflow: hidden;
        }
        ul {
            li {
                margin-top: 10px;
                position: relative;
                &:first-child {
                    margin-top: 0;
                }
                span {
                    position: absolute;
                }
                p {
                    margin-left: 72px;
                    display: inline-block;
                    vertical-align: top;
                    line-height: 18px;
                }
            }
        }
    }
    .expand {
        .c-desc-container {
            max-height: none;
        }
        .icon-arrow-down {
            display: inline-block;
            -webkit-transform: rotate(180deg);
            transform: rotate(180deg);
        }
        .comment-dropdown {
            background: none;
        }
        .c-detail-container {
            max-height: none;
        }
        .comment-dropdown-t {
            background: none;
        }
    }
    .ellipsis {
        .comment-dropdown {
            display: block;
        }
        .comment-dropdown-t {
            display: block;
        }
    }
    .c-img-list {
        // margin: 0 15px;
        position: relative;
        overflow: hidden;
        ul {
            li {
                width: 33.3%;
                float: left;
                height: 80px;
                text-align: center;
                &:first-child {
                    text-align: left;
                }
                &:last-child {
                    text-align: right;
                }
                img {
                    border-radius: 9px;
                    height: 80px;
                    width: 95%;
                    touch-action: manipulation;
                    object-fit: cover;
                }
            }
        }
    }
    .c-img-count {
        display: inline-block;
        position: absolute;
        right: -10px;
        bottom: -8px;
        span {
            position: absolute;
            z-index: 1;
            color: #fff;
            top: 6px;
            right: 15px;
            font-size: 12px;
        }
        .c-count-bg {
            height: 33px;
            width: 62px;
            background-color: #23cc77;
            border-radius: 8px;
            transform: skew(-16deg);
            -webkit-transform: skew(-16deg);
        }
    }
}

.detail-comment .no-comment {
    font-size: 14px;
    line-height: 28px;
    padding-bottom: 20px;
    text-align: center;
    background: #fff;
}

.detail-comment .comment-dropdown {
    display: none;
    position: relative;
    text-align: center;
    background: #fff;
    background: linear-gradient(top, rgba(255, 255, 255, 0), #fff 40%,#fff);
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), #fff 40%,#fff);
    margin-top: -14px;
    padding-top: 13px;
    color: #999;
}

.detail-comment .comment-dropdown-t {
    display: none;
    position: relative;
    text-align: center;
    background: #f9fbfc;
    background: linear-gradient(top, rgba(255, 255, 255, 0), #f9fbfc 40%,#f9fbfc);
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), #f9fbfc 40%, #f9fbfc);
    margin-top: -14px;
    padding-top: 13px;
    color: #999;
}

.detail-comment .pager-box {
    text-align: center;
    padding: 10px 0;
    .pager {
        color: #666;
        font-size: 1.4rem;
        padding: 5px;
        touch-action: manipulation;
        &.active {
            color: #33bc60;
            &:active {
                background-color: #e8fadf;
            }
        }
    }
    span {
        padding: 0 15px;
        font-size: 1.2rem;
    }
}

.detail-comment .ps {
    clear: both;
    color: #999;
    text-align: center;
    border-top: 1px solid #e0e0e0;
    background-color: #fff;
    padding: 10px 0;
    font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// Comment.vue